// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cF2w","content":"styles_content__3lKrS"};